import { useGetOrgConfigQuery } from 'src/services/settings/settingsApi';

const useOrgConfig = () => {
  const { data: orgConfigData } = useGetOrgConfigQuery();
  const {
    article_generation_version,
    discover_for_chats,
    discover_for_tickets,
    discover_for_voice,
    discover_viewable_tier,
    display_excluded_ticket_metrics_on_dashboard,
    display_ticket_counts_on_dashboard,
    display_ticket_metrics_on_dashboard,
    feature_flags,
    human_evals_supported_channels,
    is_assist_gpt_enabled,
    is_attachment_analysis_enabled,
    is_content_labels_enabled,
    is_discover_content_multi_segmentation_enabled,
    is_document_index_page_enabled,
    is_ticket_keyword_search_enabled,
    taxonomy_version: taxonomyVersion = null,
    train_using_replies_without_tickets,
  } = orgConfigData ?? {};

  return {
    article_generation_version,
    discover_for_chats,
    discover_for_tickets,
    discover_for_voice,
    discover_viewable_tier,
    display_excluded_ticket_metrics_on_dashboard,
    display_ticket_counts_on_dashboard,
    display_ticket_metrics_on_dashboard,
    feature_flags,
    human_evals_supported_channels,
    is_assist_gpt_enabled,
    is_attachment_analysis_enabled,
    is_content_labels_enabled,
    is_discover_content_multi_segmentation_enabled,
    is_document_index_page_enabled,
    is_ticket_keyword_search_enabled,
    taxonomyVersion,
    train_using_replies_without_tickets,
  };
};

export default useOrgConfig;
